export default __webpack_public_path__ + "static/media/logo.8fa86ea3.svg";